module.exports = __webpack_public_path__ + "img/mask_female_body_baseball_hat.023b0ee9.png";